import { render, staticRenderFns } from "./ResumePerElements.vue?vue&type=template&id=6abfce34&scoped=true"
import script from "./ResumePerElements.vue?vue&type=script&lang=js"
export * from "./ResumePerElements.vue?vue&type=script&lang=js"
import style0 from "./ResumePerElements.vue?vue&type=style&index=0&id=6abfce34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abfce34",
  null
  
)

export default component.exports